import { render, staticRenderFns } from "./InsuranceSkladUsaTable.vue?vue&type=template&id=79384a02&scoped=true"
import script from "./InsuranceSkladUsaTable.vue?vue&type=script&lang=js"
export * from "./InsuranceSkladUsaTable.vue?vue&type=script&lang=js"
import style0 from "./InsuranceSkladUsaTable.vue?vue&type=style&index=0&id=79384a02&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79384a02",
  null
  
)

export default component.exports